<template>
  <v-dialog
    v-model="agregarSituacionDialog"
    width="50%"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        rounded
        small
        color="secondary"
        class="d-inline ml-4"
        v-bind="attrs"
        v-on="on"
        @click="agregarSituacionDialog = true"
      >
        Agregar situación financiera
      </v-btn>
    </template>
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Nueva situación financiera
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="agregarSituacionDialog = false"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="situacionForm"
        >
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="situacion.fk_idCatIngresos"
                  label="Ingresos"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  item-color="secondary"
                  :items="ingresos"
                  item-value="id"
                  item-text="title"
                  :rules="required"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model.number="situacion.dependientesEconomicos"
                  label="Dependientes económicos"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-1 font-weight-bold">
                  Servicios con los que cuenta
                </div>
                <template
                  v-for="servicio, index in tipoServicio"
                >
                  <v-checkbox
                    :key="index"
                    v-model="servicios"
                    :value="servicio.id"
                    :label="servicio.title"
                    dense
                    color="secondary"
                  />
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          :disabled="!situacionForm || loading"
          @click="triggerSaveSituacion()"
        >
          Guardar situación
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  props: {
    idExpediente: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      agregarSituacionDialog: false,

      situacionForm: false,
      loading: false,

      situacion: {
        fk_idExpediente: this.idExpediente,
        fk_idCatIngresos: 0,
        fk_idCatNivelSocioeconomico: 1,
        dependientesEconomicos: 0,
        servicios: [],
      },

      servicios: [],

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('ingresos', {
      ingresos: 'getIngresos',
    }),
    ...mapGetters('nivelSocioEconomico', {
      nivelSocioeconomico: 'getNivelSocioeconomico',
    }),
    ...mapGetters('tipoServicio', {
      tipoServicio: 'getTipoServicio',
    }),

    getMaxDay() {
      return moment().format('YYYY-MM-DD');
    },
  },

  async mounted() {
    await this.fetchIngresos();
    await this.fetchNivelSocioeconomico();
    await this.fetchTipoServicio();
  },

  methods: {
    ...mapActions('ingresos', ['fetchIngresos']),
    ...mapActions('nivelSocioEconomico', ['fetchNivelSocioeconomico']),
    ...mapActions('tipoServicio', ['fetchTipoServicio']),
    ...mapActions('situacionFinanciera', ['saveSituacionFinanciera', 'fetchSituacionFinanciera']),

    async triggerSaveSituacion() {
      this.loading = true;

      this.servicios.forEach((servicio) => {
        this.situacion.servicios.push({
          fk_idCatTipoServicio: servicio,
        });
      });

      await this.saveSituacionFinanciera(this.situacion);

      this.closeDialog();
    },

    async closeDialog() {
      this.loading = false;

      this.situacion = {
        fk_idExpediente: this.idExpediente,
        fk_idCatIngresos: 0,
        fk_idCatNivelSocioeconomico: 0,
        dependientesEconomicos: 0,
        servicios: [],
      };
      await this.fetchSituacionFinanciera(this.idExpediente);
      this.agregarSituacionDialog = false;
      this.$refs.form.resetValidation();
    },
  },
};
</script>
